import { Automation } from '@/types/automations.ts';
import { AutomationContext } from '@/context/AutomationContext/AutomationContext.tsx';

export function AutomationProvider({
  automation,
  children,
}: {
  automation: Automation;
  children: React.ReactNode;
}) {
  return <AutomationContext.Provider value={automation}>{children}</AutomationContext.Provider>;
}
